import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

export interface GetMobileLabelCreateNotificationDataResponse {
	visibilityIOSBanner: boolean;
	visibilityAndroidBanner: boolean;
}

@Injectable({providedIn: 'root'})
export class MobileLabelCreateNotificationDataService {

	constructor(private http: HttpClient) { }

	public getMobileLabelCreateNotificationData(): Observable<GetMobileLabelCreateNotificationDataResponse> {
		return this.http.get<GetMobileLabelCreateNotificationDataResponse>('rest/common/banner/visibleShortcut');
	}

}
